
import React, { createContext, useContext } from 'react';

export type TopPage = 'home' | 'business' | 'studio' | 'ops';

export type BusinessTab = 'customers' | 'calendar' | 'money' | 'inbox' | 'analytics';
export type StudioTab = 'ai' | 'research' | 'media' | 'visuals' | 'assets';
export type OpsTab = 'monitor' | 'files' | 'database' | 'integrations';

export interface AppState {
  currentPage: TopPage;
  businessTab: BusinessTab;
  studioTab: StudioTab;
  opsTab: OpsTab;
  sidebarCollapsed: boolean;
  commandPaletteOpen: boolean;
  theme: 'dark';
  notifications: number;
}

export const defaultAppState: AppState = {
  currentPage: 'home',
  businessTab: 'customers',
  studioTab: 'ai',
  opsTab: 'monitor',
  sidebarCollapsed: false,
  commandPaletteOpen: false,
  theme: 'dark',
  notifications: 5,
};

export const AppStateContext = createContext<{
  appState: AppState;
  setAppState: React.Dispatch<React.SetStateAction<AppState>>;
}>({ appState: defaultAppState, setAppState: () => {} });

export function useAppState() {
  return useContext(AppStateContext);
}

// Legacy compatibility — keep Page type mapping
export type Page = TopPage;
